import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import {CreateGroupedObjects, GroupedObjects, Sale, UpdateGroupedObjects} from "./models-service";
import {IResponseResult} from "@/services/data/base_types";
import {FillBlockShowResponse} from "@/services/fill-blocks-service";

export const route_ns = `grouped_object`;

class GroupedObjectService {
  public async getObjectsByCut(cut_id: string | null): Promise<GroupedObjects[]> {
    const url = `${route_ns}/get_by_cut/${cut_id}`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    return response;
  }

  public async deleteObject(id: string): Promise<string> {
    const url = `${route_ns}/${id}`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "delete",
    });
    return response;
  }

  public async createObject(groupedObject: CreateGroupedObjects): Promise<GroupedObjects[]> {
    const url = `${route_ns}`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "post",
      data: groupedObject,
    });
    return response;
  }

  public async updateObject(id: string, groupedObject: UpdateGroupedObjects): Promise<GroupedObjects> {
    const url = `${route_ns}/${id}`;
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "put",
      data: groupedObject,
    });
    return response;
  }
}

export default new GroupedObjectService();
